import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import AnimatedPage from '../../components/AnimatedPage'
import { BackButton } from '../../components/BackButton'
import Img from '../../assets/images/DigitalSign1.png';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Digisign = () => {
    const navigate = useNavigate();
    const [isActiveButton, setisActiveButton] = useState(true);
    const onClickButton = (type) => {
        navigate(`${type}`);
    }
    useEffect(() => {
        setTimeout(() => {
            setisActiveButton(true);
        }, 560);
    }, [])

    return (
        <AnimatedPage animationType="fade">
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <BackButton />
                <motion.div
                    initial={{ opacity: 1, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2, duration: 0.5, ease: 'easeOut' }}
                    style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                    }}
                >
                    <img
                        src={Img}
                        alt=""
                        style={{
                            width: '75%',
                            height: '75%',
                            objectFit: 'contain',
                        }}
                    />
                </motion.div>
                {isActiveButton && <>
                    <Button initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2, duration: 0.5, ease: 'easeOut' }} top={898} left={1413} onClick={() => onClickButton('detail-digisign1')}>
                        <TextButton>THÁNG 7/2024</TextButton>
                    </Button>
                    <Button initial={{ opacity: 0, scale: 0}}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2, duration: 0.5, ease: 'easeOut' }} top={898} left={2100} onClick={() => onClickButton('detail-digisign2')}>
                        <TextButton>THÁNG 5/2025</TextButton>
                    </Button></>}
            </div>
        </AnimatedPage>
    )
}

export default Digisign

const rotate = keyframes`
	from { transform: translate(-50%, -50%) scale(1.4) rotate(0turn); }
	to { transform: translate(-50%, -50%) scale(1.4) rotate(1turn); }
`;

const clickAnimation = keyframes`
    0% { transform: translate(-50%, -50%) scale(1); }
    50% { transform: translate(-50%, -50%) scale(1.1); }
    100% { transform: translate(-50%, -50%) scale(1); }
`;

const Button = styled(motion.div)`
    --offset: 3px;
    position: absolute;
    height: ${props => `calc( ${props.height || 170} / 2160 * 100vh)`};
    width: ${props => `calc( ${props.width || 535} / 4096 * 100vw)`};
    top: ${props => `calc( ${props.top} / 2130 * 100vh)`};
    left: ${props => `calc( ${props.left} / 4096 * 100vw)`};
    transform: translate(-50%, -50%);
    border-radius: 1px;
    max-width: 100%;
        background: rgb(4 61 6);
    overflow: hidden;
    transition: transform 0.1s ease;
    animation: ${props => props.isClicked ? clickAnimation : 'none'} 0.3s ease;
     display: flex;
    justify-content: center;
    align-items: center;

    &::before {
        content: '';
        background: conic-gradient(transparent 270deg, ${props => props.rgb || 'rgb(255 255 255)'}, transparent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        aspect-ratio: 1 / 1;
        width: 100%;
        animation: ${rotate} 2s linear infinite;
        pointer-events: none;
    }

    &::after {
        content: '';
        background: inherit;
        border-radius: inherit;
        position: absolute;
        inset: var(--offset);
        height: calc(100% - 2 * var(--offset));
        width: calc(100% - 2 * var(--offset));
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
    }
    &:hover {
        cursor: pointer;
    }
`;

const TextButton = styled.p`
font-size: ${props => `calc( ${props.size || 40} / 4096 * 100vw)`};
font-weight: 700;
color: white;
text-align: center;
    z-index: 10;
    margin-left: calc(20 / 2160 * 100vh);
        margin-right: calc(20 / 2160 * 100vh);

`;